import React, { useState, useContext } from 'react';
import * as S from "./ModalReinvestimentoStyle";
import styled from "styled-components";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import Loading from "../../Loader";

const BodyContent = styled.div`
    text-align: center;
    color: #fff;
    h4 {
        margin: 0 0 10px 0;
        font-size: 18px;
    }
    p {
        margin: 0 0 20px 0;
        opacity: 0.8;
        font-size: 14px;
    }
`;

export default function ModalReinvestimento({ onClose, client, setClient }) {
    const [load, setLoad] = useState(false);
    const { authState } = useContext(AuthContext);

    const handleChange = async () => {
        setLoad(true);
        const base_url = process.env.REACT_APP_API_BASE_URL;
        const newReinvestValue = !client.reinvest;

        const patchOperations = [
            {
                fieldName: "reinvest",
                fieldNewValue: newReinvestValue
            }
        ];

        const headers = {
            headers: {
                Authorization: `Bearer ${authState.accessToken || ""}`,
                "X-Client-ID": client.id
            },
        };

        try {
            await axios.patch(
                `${base_url}client/by-token`,
                patchOperations,
                headers
            );

            setClient(prevClient => ({ ...prevClient, reinvest: newReinvestValue }));
            
            alert("Status de reinvestimento alterado com sucesso!");
            onClose(true);
        } catch (error) {
            alert(`Ocorreu um erro: ${error.response?.data?.message || error.message}`);
        } finally {
            setLoad(false);
        }
    }

    return (
        <S.ModalOverlay>
            <S.ModalContainer size="small">
                <Loading load={load} />
                <S.ModalHeader>
                    <h3>Reinvestimento Automático</h3>
                    <S.CloseButton onClick={() => onClose(false)}>&times;</S.CloseButton>
                </S.ModalHeader>
                <S.ModalBody>
                    <BodyContent>
                        <h4>Status Atual: {client.reinvest ? "ATIVADO" : "DESATIVADO"}</h4>
                        <p>Deseja alterar o status de reinvestimento automático para este cliente?</p>
                    </BodyContent>
                </S.ModalBody>
                <S.ModalFooter>
                    <S.CancelButton onClick={() => onClose(false)}>Cancelar</S.CancelButton>
                    <S.SaveButton onClick={handleChange}>
                        {client.reinvest ? "Desativar Reinvestimento" : "Ativar Reinvestimento"}
                    </S.SaveButton>
                </S.ModalFooter>
            </S.ModalContainer>
        </S.ModalOverlay>
    );
}